import type { ChainId } from '@shapeshiftoss/caip'
import {
  arbitrumChainId,
  avalancheChainId,
  baseChainId,
  bchChainId,
  bscChainId,
  btcChainId,
  cosmosChainId,
  dogeChainId,
  ethChainId,
  gnosisChainId,
  ltcChainId,
  optimismChainId,
  polygonChainId,
  solanaChainId,
  thorchainChainId,
} from '@shapeshiftoss/caip'

import type { CommonFiatCurrencies } from '@/lib/fiatCurrencies/fiatCurrencies'

export const SUPPORTED_ONRAMPER_FIAT_CURRENCIES: CommonFiatCurrencies[] = [
  'AOA',
  'AUD',
  'BBD',
  'BZD',
  'BMD',
  'BRL',
  'GBP',
  'BND',
  'BGN',
  'CAD',
  'XAF',
  'CLP',
  'CNY',
  'COP',
  'KMF',
  'CRC',
  'HRK',
  'CZK',
  'DKK',
  'DJF',
  'DOP',
  'XCD',
  'EGP',
  'EUR',
  'FKP',
  'FJD',
  'GEL',
  'GHS',
  'GIP',
  'GTQ',
  'HNL',
  'HKD',
  'HUF',
  'ISK',
  'IDR',
  'ILS',
  'JMD',
  'JPY',
  'JOD',
  'KZT',
  'KES',
  'KWD',
  'KGS',
  'MGA',
  'MWK',
  'MYR',
  'MRU',
  'MXN',
  'MDL',
  'MAD',
  'MZN',
  'TWD',
  'NZD',
  'NGN',
  'NOK',
  'OMR',
  'PKR',
  'PGK',
  'PYG',
  'PEN',
  'PHP',
  'PLN',
  'RON',
  'RWF',
  'STN',
  'SCR',
  'SGD',
  'SBD',
  'ZAR',
  'KRW',
  'LKR',
  'SRD',
  'SZL',
  'SEK',
  'CHF',
  'TJS',
  'TZS',
  'THB',
  'TOP',
  'TRY',
  'TMT',
  'UGX',
  'USD',
  'UYU',
  'VND',
]

// Base mapping from ChainId to Onramper network names
export const CHAIN_ID_TO_ONRAMPER_NETWORK: Record<ChainId, string> = {
  [btcChainId]: 'bitcoin',
  [bchChainId]: 'bitcoincash',
  [dogeChainId]: 'dogecoin',
  [ltcChainId]: 'litecoin',
  [ethChainId]: 'ethereum',
  [avalancheChainId]: 'avaxc',
  [optimismChainId]: 'optimism',
  [bscChainId]: 'bsc',
  [polygonChainId]: 'polygon',
  [gnosisChainId]: 'gnosis',
  [arbitrumChainId]: 'arbitrum',
  [baseChainId]: 'base',
  [cosmosChainId]: 'cosmos',
  [thorchainChainId]: 'thorchain',
  [solanaChainId]: 'solana',
} as const

export const ONRAMPER_NETWORK_TO_CHAIN_ID: Record<string, ChainId> = Object.fromEntries(
  Object.entries(CHAIN_ID_TO_ONRAMPER_NETWORK).map(([chainId, network]) => [network, chainId]),
)

export const getChainIdFromOnramperNetwork = (network: string): ChainId | undefined => {
  return ONRAMPER_NETWORK_TO_CHAIN_ID[network]
}
